import React from "react";
import { DataTable, DataTableRowEditCompleteEvent } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { Button } from "primereact/button";
import { CustomerAddressModel1 } from "../../models/cust-address/cust-address-model";

interface Props {
  userData: any[];
  loading: boolean;
  pageNumber: number;
  pageSize: number;
  totalRecords: number;
  onPageChange: (event: { first: number; rows: number }) => void;
  onRowEditComplete: (e: DataTableRowEditCompleteEvent) => void;
  routeCodeOptions: { label: string; value: number }[];
  otherActionTemplate: (rowData: CustomerAddressModel1) => JSX.Element;
  routeCodeEditor: (options: any) => JSX.Element;
  emptyMessage?: string; 
}

const OrderTabPanel: React.FC<Props> = ({
  userData,
  loading,
  pageNumber,
  pageSize,
  totalRecords,
  onPageChange,
  onRowEditComplete,
  routeCodeOptions,
  otherActionTemplate,
  routeCodeEditor,
  emptyMessage,
}) => {
  return (
    <div className="card border-noround p-2">
      <DataTable
        value={userData}
        loading={loading}
        editMode="row"
        dataKey="userAddressID"
        paginator
        rows={pageSize}
        totalRecords={totalRecords}
        lazy
        rowsPerPageOptions={[5, 10, 25, 50]}
        first={(pageNumber - 1) * pageSize}
        onPage={onPageChange}
        onRowEditComplete={onRowEditComplete}
        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
        currentPageReportTemplate={`{first} to {last} of ${totalRecords}`}
        tableStyle={{ minWidth: "50rem" }}
        emptyMessage={emptyMessage}
      >
        <Column field="primaryContactNbr" header="Mobile #" />
        <Column field="userName" header="User Name" />
        <Column field="address1" header="Address" />
        <Column field="areaName" header="Area" />
        <Column field="subDistrictName" header="Sub District" />
        <Column field="districtName" header="District" />
        <Column field="stateName" header="State" />
        <Column
          field="routeCodeID"
          header="Route Code"
          editor={(options) => routeCodeEditor(options)}
          body={(rowData) =>
            routeCodeOptions.find((rc) => rc.value === rowData.routeCodeID)?.label || "Not Assigned"
          }
          style={{ textAlign: "right", width: "8em" }}
        />
        <Column header="Geo Code" body={(rowData) => otherActionTemplate(rowData)} />
        <Column rowEditor header="Action" headerStyle={{ width: "5rem" }} bodyStyle={{ textAlign: "center" }} />
      </DataTable>
    </div>
  );
};

export default OrderTabPanel;
